export default __webpack_public_path__ + "static/media/home-active.8ac4b374.svg";